import React from 'react';
import { MDBContainer, MDBDataTable, MDBRow, MDBCol, MDBBtn, MDBSelect, MDBCard, MDBCardBody } from 'mdbreact';
import DataLayer from '../Utilities/DataLayer';
import Header from './ComponentFragments/Header';
import Formatter from '../Utilities/Formatter';

export default class InactiveDems extends React.Component {

    constructor(props) {
        super(props);
        this.props.loaderOn();
        this.state = {
            reportData: [],
            yearData: [],
            fromWeekData: [],
            unitData: [],
            toWeekData: [],
            selectedYear: 0,
            selectedFromWeek: 0,
            selectedToWeek: 0,
            selectedUnit: 0,
            selectedUnitName: '',
            tableHidden: true
        }
        this.formatter = new Formatter();
        this.handleYearSelectChange = this.handleYearSelectChange.bind(this);
        this.handleFromSelectChange = this.handleFromSelectChange.bind(this);
        this.handleToSelectChange = this.handleToSelectChange.bind(this);
        this.getInactiveDems = this.getInactiveDems.bind(this);
        this.handleUnitSelectChange = this.handleUnitSelectChange.bind(this);
    }

    async loadWeeksForYear(year) {
        this.props.loaderOn();
        var dl = new DataLayer();
        let result = await dl.Get('/common/getweeksforyear?yearId=' + year, 200);
        let fromWeeksData = [];
        let toWeeksData = [];
        result.data.forEach((week) => fromWeeksData.push({ checked: false, value: week.value, text: week.label }));
        result.data.forEach((week) => toWeeksData.push({ checked: false, value: week.value, text: week.label }));

        fromWeeksData[0].checked = true;
        toWeeksData[0].checked = true;
        this.setState({
            fromWeekData: fromWeeksData,
            toWeekData: toWeeksData,
            selectedFromWeek: fromWeeksData[0].value,
            selectedToWeek: toWeeksData[0].value
        })

        this.props.loaderOff();
    }

    handleUnitSelectChange(selected) {
        let unitName = "";
        for (var i = 0; i < this.state.unitData.length; i++) {
            if (this.state.unitData[i].value == selected[0]) {
                unitName = this.state.unitData[i].text
            }
        }
        this.setState({
            selectedUnit: selected[0],
            selectedUnitName: unitName
        });
    }

    handleYearSelectChange(selected) {
        this.setState({
            selectedYear: selected[0]
        });
        this.loadWeeksForYear(selected[0])
    }

    handleFromSelectChange(selected) {
        this.setState({
            selectedFromWeek: selected[0]
        });
    }

    handleToSelectChange(selected) {
        this.setState({
            selectedToWeek: selected[0]
        });
    }

    async componentWillMount() {
        this.props.loaderOn();
        var dl = new DataLayer();
        let result = await dl.Get('/common/getyears', 200);
        let yearsData = [];
        result.data[0].forEach((year) => yearsData.push({ checked: false, value: year.value, text: year.label }));
        yearsData[0].checked = true;

        let TMAUser = JSON.parse(localStorage.getItem("TMAUser"));
        let unitsData = [];
        if (TMAUser.data.statusCode1 == 'T') {
            let unitResponse = await dl.Get('/teamleader/getunitslist', 200)
            let allUnits = { checked: true, value: 0, text: 'All Team Units' }
            unitsData.push(allUnits);
            unitResponse.data.data.forEach((unit) => unitsData.push({ checked: false, value: unit.unitId, text: unit.unitName }));
            //unitsData[0].checked = true;
        }

        this.setState({
            yearData: yearsData,
            selectedYear: yearsData[0].value,
            unitData: unitsData
        })
        this.props.loaderOff();
    }

    async getInactiveDems() {
        this.props.loaderOn();
        var dl = new DataLayer();
        let TMAUser = JSON.parse(localStorage.getItem("TMAUser"));
        let unitId = TMAUser.data.statusCode1 == "T" ? this.state.selectedUnit : TMAUser.data.unitId
        let result = await dl.Get('/demonstrator/getInactiveDems?fromWeek=' + this.state.selectedFromWeek + '&toWeek=' + this.state.selectedToWeek + '&unitId=' + unitId, 200);
        let demRecs = [];
        let rec;
        result.data.map((perfRec) => {
            let telNo = "tel:" + perfRec.telephoneCell;
            rec = {
                unitName: perfRec.unitName,
                managerFirstNames: perfRec.managerFirstNames,
                managerSurname: perfRec.managerSurname,
                sfCurrentCode: perfRec.sfCurrentCode,
                firstNames: perfRec.firstNames,
                surname: perfRec.surname,
                telephoneCell: [<a href={telNo}>{perfRec.telephoneCell}</a>],
                startWeekId: perfRec.startWeekId,
                status: perfRec.statusCode1 + '' + perfRec.statusCode2,
                lastActiveWeekId: perfRec.lastActiveWeekId == -1 ? [<span style={{ color: "red" }}>Not Active</span>] : perfRec.lastActiveWeekId
            };
            demRecs.push(rec);
        });

        let tableData = {
            columns: [{
                label: 'Unit Name',
                field: 'unitName',
                sort: 'asc'
            },
            {
                label: 'Manager Name',
                field: 'managerFirstNames',
                sort: 'asc'
            },
            {
                label: 'Manager Surname',
                field: 'managerSurname',
                sort: 'asc'
            }, {
                label: 'Dem Code',
                field: 'sfCurrentCode',
                sort: 'asc'
            }, {
                label: 'Dem Name',
                field: 'firstNames',
                sort: 'asc'
            }, {
                label: 'Dem Surname',
                field: 'surname',
                sort: 'asc'
            }, {
                label: 'Tel.',
                field: 'telephoneCell',
                sort: 'asc'
            }, {
                label: 'Start Week',
                field: 'startWeekId',
                sort: 'asc'
            }, {
                label: 'Type',
                field: 'status',
                sort: 'asc'
            }, {
                label: 'Last Active',
                field: 'lastActiveWeekId',
                sort: 'asc'
            }],
            rows: demRecs
        }
        this.setState({
            reportData: tableData,
            tableHidden: false
        });
        this.props.loaderOff();
    }

    render() {
        let TMAUser = JSON.parse(localStorage.getItem("TMAUser"));
        let statusType = TMAUser.data.statusCode1;
        let subHeaderText = "(Click Go to load inactive demonstrator report for selected weeks. Select All Team Units to run for Team.)";
        if (statusType == "M") {
            subHeaderText = "(Click Go to load inactive demonstrator report for selected weeks.)"
        }
        return (
            <div>
                <Header headerText='Inactive Demonstrators'
                    subHeaderText={subHeaderText}
                    hideSearch='true'
                />
                <MDBCard>
                    <MDBCardBody>
                        <MDBRow>
                            <MDBCol md="6">
                                <MDBContainer>
                                    <MDBRow className="mt-3">
                                        <MDBCol>
                                            <MDBSelect label="Year..."
                                                options={this.state.yearData}
                                                selected="Filter"
                                                getValue={this.handleYearSelectChange}
                                                required
                                            />
                                        </MDBCol>

                                    </MDBRow>
                                    <MDBRow className="mt-3">
                                        <MDBCol>
                                            <MDBSelect label="From Week..."
                                                options={this.state.fromWeekData}
                                                selected="Filter"
                                                getValue={this.handleFromSelectChange}
                                                required
                                            />
                                        </MDBCol>
                                    </MDBRow>
                                    <MDBRow className="mt-3">
                                        <MDBCol>
                                            <MDBSelect label="To Week..."
                                                options={this.state.toWeekData}
                                                selected="Filter"
                                                getValue={this.handleToSelectChange}
                                                required
                                            />
                                        </MDBCol>
                                    </MDBRow>
                                    {statusType == "T" ? <MDBRow className="mt-3">
                                        <MDBCol>
                                            <MDBSelect label="Unit..."
                                                options={this.state.unitData}
                                                selected="Filter"
                                                getValue={this.handleUnitSelectChange}
                                                required
                                            />
                                        </MDBCol>
                                    </MDBRow> : <div></div>}
                                    <MDBRow>
                                        <MDBCol>
                                            <MDBBtn onClick={this.getInactiveDems}>Go</MDBBtn>
                                        </MDBCol>
                                    </MDBRow>
                                </MDBContainer>
                            </MDBCol>


                        </MDBRow>

                        <br />

                        <div hidden={this.state.tableHidden}>
                            <hr />
                            <MDBContainer>
                                <MDBRow>
                                    {this.state.selectedUnit == 0 && statusType == "T" ?
                                        <div style={{ fontWeight: "bold" }}>Inactive Demonstrator Results for<br />Weeks {this.state.selectedFromWeek} to {this.state.selectedToWeek}</div> :
                                        <div style={{ fontWeight: "bold" }}>Inactive Demonstrator Results for{this.state.selectedUnitName}<br />Weeks {this.state.selectedFromWeek} to {this.state.selectedToWeek}</div>}
                                </MDBRow>


                            </MDBContainer>
                            <div style={{ paddingBottom: "15px" }}></div>
                            <MDBContainer>
                                <MDBDataTable
                                    responsive
                                    striped
                                    bordered
                                    hover
                                    data={this.state.reportData}
                                    paging={false}
                                    autoWidth
                                    searching={false}
                                />;
                            </MDBContainer>
                        </div>
                    </MDBCardBody>
                </MDBCard>
            </div>
        );
    }


}
